import { useRef, useEffect, useState } from 'react';
import { getActiveState } from '../helpers/titreHelper';
import { useGetParams } from './useGetParams';
import { useInterval } from './useInterval';

export const useBroadcast = () => {
  const { user, cols, rows } = useGetParams();

  const [currentState, setCurrentState] = useState(null);
  const [isVisible, setIsVisible] = useState(null);

  const lastMessageIdRef = useRef(0);
  const messagesRef = useRef([]);

  const [messages, setMessages] = useState([]);

  // id предыдущего запущенного интерактива
  const prevIdBroadcast = useRef('');
  // id текущего запущенного интерактива
  const iactiveIdRef = useRef('');

  const protocol = window?.location?.protocol || 'https:';

  const getBroadcastInfo = async () => {
    if (!user) {
      return;
    }

    try {
      const response = await fetch(
        `${protocol}//api.stream.iactive.pro/titreInfo?user=${user}&from=${lastMessageIdRef.current}&type=1`,
      );
      const data = await response.json();

      if (!data) return;

      let { messagesList, deletedMessagesIdList, visibility, iactiveId } = data;

      // очистка при остановке\смене интерактива, при остановке iactiveId = ""
      if (iactiveIdRef.current !== iactiveId) {
        if (
          iactiveId &&
          iactiveId !== prevIdBroadcast.current // если === , значит prevIdBroadcast был остановлен и теперь запущен, и не нужно обнулять
        ) {
          messagesRef.current = [];
          setMessages([]);
        }
      }

      // сохранение id нового запущенного интерактива.
      if (iactiveId && iactiveId !== prevIdBroadcast.current) {
        prevIdBroadcast.current = iactiveId;
      }

      // Определяем видимость титра
      if (!visibility && visibility !== isVisible) {
        setIsVisible(false);
        return;
      } else if (visibility && visibility !== isVisible) {
        setIsVisible(true);
      }

      // Определяем состояние (S1, S2 ...)
      if (
        data?.statusList[0]?.state &&
        getActiveState(data?.statusList[0]?.state) !== currentState
      ) {
        setCurrentState(getActiveState(data?.statusList[0].state));
      }

      // если список сообщений пустой
      if (
        !messagesList ||
        (Array.isArray(messagesList) && messagesList.length === 0)
      ) {
        // если имеются в списке сообщений удаленные
        if (
          messagesRef.current.some((el) => {
            let ids = [el.col?.idMsg, el.row?.idMsg, el.visible?.idMsg];
            return ids.find((i) => deletedMessagesIdList.includes(Number(i)));
          })
        ) {
          messagesRef.current = messagesRef.current.map((msg) => {
            const col = msg.col?.idMsg ? Number(msg.col.idMsg) : 0;
            const row = msg.row?.idMsg ? Number(msg.row?.idMsg) : 0;
            const visible = msg.visible?.idMsg ? Number(msg.visible?.idMsg) : 0;

            if (
              deletedMessagesIdList.includes(col) ||
              deletedMessagesIdList.includes(row) ||
              deletedMessagesIdList.includes(visible)
            ) {
              let newMsg = { ...msg };

              if (deletedMessagesIdList.includes(col)) {
                newMsg = {
                  ...newMsg,
                  col: {
                    start: '',
                    idMsg: '',
                  },
                };
              }
              if (deletedMessagesIdList.includes(row)) {
                newMsg = {
                  ...newMsg,
                  row: {
                    start: '',
                    idMsg: '',
                  },
                };
              }

              if (deletedMessagesIdList.includes(visible)) {
                newMsg = {
                  ...newMsg,
                  visible: {
                    status: false,
                    idMsg: '',
                  },
                };
              }

              return newMsg;
            } else return msg;
          });

          setMessages(messagesRef.current);
        }

        //запоминаем id последнего сообщения, для дальнейших запросов и обнуляем при переключении интерактивов
        if (iactiveIdRef.current && iactiveIdRef.current !== iactiveId) {
          lastMessageIdRef.current = 0;
          iactiveIdRef.current = iactiveId;
          return;
        } else {
          iactiveIdRef.current = iactiveId;
          lastMessageIdRef.current =
            messagesList[0]?.id || lastMessageIdRef.current;
        }
        return;
      }

      //запоминаем id последнего сообщения, для дальнейших запросов и обнуляем при переключении интерактивов
      if (iactiveIdRef.current && iactiveIdRef.current !== iactiveId) {
        lastMessageIdRef.current = 0;
        iactiveIdRef.current = iactiveId;
        return;
      } else {
        iactiveIdRef.current = iactiveId;
        lastMessageIdRef.current =
          messagesList[0]?.id || lastMessageIdRef.current;
      }

      messagesList.reverse();

      messagesList.forEach((el) => {
        const currentElem = messagesRef.current.find(
          (res) => res.message.id === el.message.id,
        );
        const numTitreTag = Number(el.titrTag.slice(1));

        // стадия больше, чем всего колонок и строк
        const notRow = numTitreTag > cols.length + 1 + rows.length;

        // стадия разделитель
        // if (numTitreTag === cols.length + 1) {
        //   return;
        // }

        if (currentElem) {
          // значит это позиция строки
          if (numTitreTag > cols.length + 1) {
            messagesRef.current = messagesRef.current.map((m) => {
              if (m.message.id === currentElem.message.id) {
                return {
                  ...m,
                  timeAdd: el.timeAdd,
                  row: {
                    start: notRow ? '' : numTitreTag - (cols.length + 1),
                    idMsg: el.id,
                  },
                };
              } else return m;
            });
          } else if (numTitreTag <= cols.length) {
            messagesRef.current = messagesRef.current.map((m) => {
              if (m.message.id === currentElem.message.id) {
                return {
                  ...m,
                  timeAdd: el.timeAdd,
                  col: {
                    start: numTitreTag,
                    idMsg: el.id,
                  },
                };
              } else return m;
            });
          } else if (numTitreTag === cols.length + 1) {
            messagesRef.current = messagesRef.current.map((m) => {
              if (m.message.id === currentElem.message.id) {
                return {
                  ...m,
                  timeAdd: el.timeAdd,
                  visible: {
                    status: true,
                    idMsg: el.id,
                  },
                };
              } else return m;
            });
          }
        } else {
          let newEl = {};

          // значит это позиция разделителя
          if (numTitreTag === cols.length + 1) {
            newEl = {
              ...el,
              visible: {
                status: true,
                idMsg: el.id,
              },
            };
          }

          if (numTitreTag > cols.length + 1) {
            newEl = {
              ...el,
              row: {
                start: notRow ? '' : numTitreTag - (cols.length + 1),
                idMsg: el.id,
              },
            };
            // значит это позиция колонки
          } else if (numTitreTag <= cols.length) {
            newEl = {
              ...el,
              col: {
                start: numTitreTag,
                idMsg: el.id,
              },
            };
          }

          messagesRef.current = [...messagesRef.current, newEl];
        }
      });

      messagesRef.current = messagesRef.current.sort(
        (a, b) => Number(a.timeAdd) - Number(b.timeAdd),
      );

      setMessages(messagesRef.current);
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    getBroadcastInfo().then(() => {});
  }, []);

  // Получение информации о титре
  useInterval(getBroadcastInfo, 1000);

  return {
    currentState,
    isVisible,
    messages,
  };
};
